module.exports = __webpack_public_path__ + "static/salt3-a05213547fae6e633f0c52e2a76c0a33.png";